@use "~dso-toolkit/src/utilities";

:host {
  display: block;
  overflow-y: hidden;
}

:host(.dso-hide) {
  display: none;
}

:host(:not(.dso-animate-ready)) {
  position: absolute;
  visibility: hidden;
}

:host([open]) {
  position: inherit;
  visibility: inherit;
  overflow-y: visible;
}

@include utilities.box-sizing();

.sr-only {
  @include utilities.sr-only();
}
